import useDarkMode from '@hooks/use-dark-mode'
import { AuthType, AuthTypeProvider } from '@lib/auth-type'
import { LoginView } from '@lib/views'
import React, { FC, useEffect, useState } from 'react'
import { useSearchParams } from 'react-router'
import StartLoginView from '@views/login/StartLogin'
import VerifyEmailAddressView from '@views/login/VerifyEmailAddress'
import VerifyPasswordView from '@views/login/VerifyPassword'
import VerifyPhoneNumberView from '@views/login/VerifyPhoneNumber'

interface LoginPageProps {
  authType?: AuthType
}

const LoginPage: FC<LoginPageProps> = ({ authType = AuthType.LogIn }) => {
  const darkMode = useDarkMode()
  const [searchParams] = useSearchParams()

  const [paramView, setParamView] = useState<LoginView | undefined>()
  const [view, setView] = useState<LoginView>(paramView || LoginView.StartLogin)

  useEffect(() => {
    if (searchParams.get('view')) {
      setParamView(searchParams.get('view') as LoginView)
    }
  }, [searchParams])

  return (
    <AuthTypeProvider value={authType}>
      <div className={darkMode ? 'dark' : ''}>
        <main className="bg-background w-screen min-h-screen flex flex-col items-center justify-center">
          <div className="flex flex-col items-center w-full">
            {darkMode ? (
              <img className="max-h-12" src="/images/ancho-logo-white.svg" />
            ) : (
              <img className="max-h-12" src="/images/ancho-logo-black.svg" />
            )}
          </div>
          <div className="w-full flex flex-col items-center mt-6">
            {view === LoginView.StartLogin && (
              <StartLoginView setView={setView} />
            )}
            {view === LoginView.VerifyEmailAddress && (
              <VerifyEmailAddressView setView={setView} />
            )}
            {view === LoginView.VerifyPassword && <VerifyPasswordView />}
            {view === LoginView.VerifyPhoneNumber && <VerifyPhoneNumberView />}
          </div>
        </main>
      </div>
    </AuthTypeProvider>
  )
}

export default LoginPage
